export const SET_EXPERT_DATA = 'SET_EXPERT_DATA'
export const CHANGE_EXPERT_DATA = 'CHANGE_EXPERT_DATA'
export const SET_CHECK_WORKS = 'SET_CHECK_WORKS'